import dayjs from 'dayjs';
import { useMemo } from 'react';

import useFetchMyTasks from 'src/Hooks/Queries/useFetchMyTasks';

/**
 * Tasks already past their due date. Shared by the header button (desktop) and the
 * avatar menu entry (mobile), so both always show the same figure.
 */
const useOverdueTaskCount = (): { overdueCount: number; isLoading: boolean } => {
  const { data: tasks, isLoading } = useFetchMyTasks();

  const overdueCount = useMemo(() => {
    if (!tasks) return 0;
    const startOfDay = dayjs().startOf('day');
    return tasks.filter(task => task.dueDate && dayjs(task.dueDate).isBefore(startOfDay)).length;
  }, [tasks]);

  return { overdueCount, isLoading };
};

export default useOverdueTaskCount;
